import React from "react";

import img1 from "../img/Mobiliario/Espejo.png";
import img2 from "../img/Mobiliario/lavabo.webp";
import img3 from "../img/Mobiliario/cerraduras.jpg";
import img4 from "../img/Mobiliario/Puerta.png";
import logo from "../img/logoAmnorte.png";

import "../styles/proximamente.css";

const Mobiliario = () => {
    const productos = [
        { nombre: "Espejos", imagen: img1 },
        { nombre: "Lavabos", imagen: img2 },
        { nombre: "Cerraduras", imagen: img3 },
        { nombre: "Puertas", imagen: img4 },
    ];

    return (
        <div className="proximamente-container fondo-mobiliario">
            <div className="proximamente-overlay">

                {/* NAVBAR SUPERIOR */}
                <nav className="navbar-mobiliario">
                    <div className="nav-left">
                        <img src={logo} alt="Logo Aymdelnorte" className="nav-logo" />
                    </div>

                    <div className="nav-right">
                        {/* <a href="" className="nav-link">Inicio</a>
                        <a href="" className="nav-link">Servicios</a>
                        <a href="" className="nav-link">Certificaciones</a>
                        <a href="" className="nav-link">Contacto</a> */}
                    </div>
                </nav>


                <h1 className="proximamente-titulo">Próximamente</h1>

                <p className="proximamente-texto">
                    Estamos preparando nuestro catálogo completo de mobiliario, gabinetes, puertas y accesorios.
                </p>

                <div className="catalogos-grid">
                    {productos.map((item, index) => (
                        <div className="producto-card" key={index}>
                            <h2>{item.nombre}</h2>

                            <img
                                src={item.imagen}
                                alt={item.nombre}
                                className="producto-img"
                            />
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};

export default Mobiliario;
